import { category } from '@bofrak-backend/shared-ui';

export const routes = {
  ...category,
  add_new_item: '/add_new_item',
  home: '/items',
  newProduct:'/add-product'
} as const;
